import { ref, useContext } from '@nuxtjs/composition-api';
import { CustomHeaders } from '~/types/core';

export function useStripeOrder()  {
  const { app } = useContext();
  const loading = ref(false);
  const error = ref(null);

  const placeStripeOrder = async (cart: string, customHeaders:CustomHeaders) => {
    let result = '';

    try {
      loading.value = true;

      // @ts-ignore
      const { data } = await app.$vsf.$magento.api.placeOrderByStripe(cart, undefined, customHeaders );
      result = data;
      error.value = null;
    } catch (err) {
      console.log('error');
      error.value = err;
    } finally {
      loading.value = false;
    }
    // @ts-ignore
    return result;
  };

  return {
    placeStripeOrder,
    loading,
    error,
  };
}

export default useStripeOrder;
